import { useQuery } from "@tanstack/react-query";
import { __ZonasFranca } from "request/configuration/__ZonasFranca";

// Hook para obtener zonas franca sin paginación
export const useZonasFrancaNotPaginate = (token, enabled = true) => {
  return useQuery({
    queryKey: ["zonasFrancaNotPaginate"],
    queryFn: async () => {
      const res = await __ZonasFranca(token);
      
      if (res.data.status?.code === 403) {
        throw new Error(res?.data?.status?.message);
      }
      
      // Mapear los datos al formato esperado
      return res?.data?.status?.data?.map((item) => ({
        label: item.name_freeZone,
        value: item?.id,
      })) || [];
    },
    enabled: enabled && !!token,
    staleTime: 10 * 60 * 1000, // 10 minutos (zonas franca cambian menos frecuentemente)
    gcTime: 15 * 60 * 1000, // 15 minutos
    refetchOnWindowFocus: false,
    retry: 2,
    retryDelay: 1000
  });
};
